<template>
  <van-overlay :show="visible" :lock-scroll="false">
    <div class="popup" @click.stop>
      <div class="contain-box">
        <div class="popup-main-close">
          <van-icon
            @click="clickClose"
            name="cross"
            color="rgb(151, 151, 151)"
            size="25px" />
        </div>
        <div style="margin-top: 60px"></div>
        <div class="contian-item">
          <div class="title">充值号码</div>
          <van-field
            class="item-field"
            v-model="phon"
            type="tel"
            maxlength="11"
            clearable
            placeholder="请输入要充值的手机号码" />
        </div>
        <div class="contian-item">
          <div class="title">确认号码</div>
          <van-field
            class="item-field"
            v-model="configPhone"
            type="tel"
            maxlength="11"
            clearable
            placeholder="请输入要充值的手机号码" />
        </div>
        <div class="sure-bg">
          <template v-if="isdisabled">
            <van-button class="disable-btn-bg">确定充值</van-button>
          </template>
          <template v-else>
            <van-button class="btn-bg" @click="clickSure">确定充值</van-button>
          </template>
        </div>
      </div>
    </div>
  </van-overlay>
</template>
  <script>
import { Field, Icon, Overlay, Toast } from "vant"
import { mobile } from "../utils/validate"
export default {
  name: "BaseCloseTipsPop",
  components: {
    [Overlay.name]: Overlay,
    [Icon.name]: Icon,
    [Field.name]: Field
  },
  model: {
    prop: "visible"
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isdisabled: {
      type: Boolean,
      default: false
    },
    defaultPhone: ""
  },
  data() {
    return {
      phon: "",
      configPhone: ""
    }
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.phon = this.defaultPhone
        this.configPhone = this.defaultPhone
      }
    }
  },
  methods: {
    clickClose() {
      this.$emit("onClose", "update:visible", false)
      this.$emit("onCloseClick")
    },
    clickSure() {
      if (this.phon.length < 11 || !mobile(this.phon)) {
        Toast("请输入正确的充值号码")
        return
      }
      if (this.configPhone.length < 11 || !mobile(this.configPhone)) {
        Toast("请输入正确的确认号码")
        return
      }
      if (this.phon != this.configPhone) {
        Toast("两次输入的手机号码不一致！")
        return
      }
      this.$emit("update:visible", false)
      this.$emit("onSureClick", this.phon)
    }
  }
}
</script>
        
  <style lang="less" scoped>
.van-overlay {
  z-index: 100;
}
.popup {
  margin-left: 20px;
  width: calc(100vw - 40px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  .contain-box {
    position: relative;
    background-color: rgb(250, 238, 226);
    border-radius: 10px;
    text-align: left;
    width: 100%;
    .popup-main-close {
      position: absolute;
      top: 15px;
      right: 15px;
    }
    .title {
      text-align: left;
      margin: 20px 40px 0 20px;
      color: rgb(100, 67, 50);
      font-size: 16px;
      font-weight: 900;
      min-height: 16px;
      //   text-shadow: 2px 2px 5px rgb(189, 150, 136);
    }
    .item-field {
      text-align: left;
      margin: 10px 0 10px 20px;
      color: rgb(60, 60, 60);
      font-size: 16px;
      padding: 10px 15px;
      width: calc(100% - 70px);
    }
    .sure-bg {
      margin: 40px 50px 40px 20px;
      .disable-btn-bg,
      .btn-bg {
        width: 100%;
        border-radius: 0px;
        border: 0;
        background-color: rgb(221, 119, 60);
        color: white;
        font-size: 15px;
        padding: 20px 0;
        // -moz-box-shadow: 2px 2px 5px rgb(155, 155, 155);
        // -webkit-box-shadow: 2px 2px 5px rgb(155, 155, 155);
        // box-shadow: 2px 2px 10px rgb(155, 155, 155);
      }
      .disable-btn-bg {
        background-color: rgb(118, 118, 118);
      }
    }
  }
}
</style>